






import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    keepAlive: {
      type: Boolean,
      default: true,
    },
  },
})
export default class RouteView extends Vue {
  public keepAlive!: boolean;

  get keepAliveActive() {
    const routeMeta = this.$route.meta;
    const storeGetters = this.$store.getters;
    let active = false;

    if (!storeGetters.multiTab && routeMeta.keepAlive === false) {
      active = false;
    } else {
      if (this.keepAlive || storeGetters.multiTab || routeMeta.keepAlive) {
        active = true;
      } else {
        active = false;
      }
    }
    return active;
  }
}
